<template>
  <div
    v-loading="state.loading"
    style="position: absolute; top: 0; left: 0; right: 0; bottom: 0"
    element-loading-text="加载中..."
  >
    <iframe ref="frameRefs" style="height: 100%; width: 100%" :src="frameSrc" />
  </div>
</template>
<script setup>
import { nextTick, unref } from "vue";
const frameRefs = ref(null);

const frameSrc = defineModel("frameSrc");

const state = ref({
  loading: false
});
function hideLoading() {
  state.value.loading = false;
}
function init() {
  nextTick(() => {
    const iframe = unref(frameRefs);
    if (!iframe) return;
    const _frame = iframe;
    if (_frame.attachEvent) {
      _frame.attachEvent("onload", () => {
        hideLoading();
      });
    } else {
      iframe.onload = () => {
        hideLoading();
      };
    }
  });
}
onMounted(() => {
  if (frameSrc.value) {
    init();
  }
});
</script>
<style scoped lang="scss"></style>
